// extracted by mini-css-extract-plugin
module.exports = {"workflow":"Workflow_workflow__1JBR6","active":"Workflow_active__3plhh","circle":"Workflow_circle__djEki","label":"Workflow_label__3untX"};